import DateRangeFn from '../models/date-range';
import { getQueryOptions } from '../shared/material_components/column-filter/helpers';

// eslint-disable-next-line no-shadow
export enum HomeFilterFields {
  CreatedAt = 'server_created_at',
  DueDate = 'due_date',
}
export interface RangeDateOption {
  key: string,
  operator: string,
  dates?: RangeDates,
  editCustom?: boolean,
}

export interface RangeDates {
  fromDate: Date | null,
  toDate: Date | null,
}

export const homeFilters = {
  notCompletedTasks: [{
    field: 'status',
    operator: 'not_equal',
    value: ['Complete'],
  }],
  completedTasks: [{
    field: 'status',
    operator: 'equal',
    value: ['Complete'],
  }],
};

export const sortBy = {
  dueDate: [{
    id: 'due_date',
    desc: false,
  }],
  createdDate: [{
    id: 'created_at',
    desc: true,
  }],
};

export const dynamicRangeDateFilters = (
  filterField: HomeFilterFields,
  rangeDate: RangeDateOption,
) => {
  const customDates = rangeDate.dates;
  if (rangeDate.key !== 'Custom') {
    return (
      [{
        field: filterField,
        operator: rangeDate.operator,
        value: [],
        options: getQueryOptions(filterField),
      }]
    );
  }

  if (customDates && customDates.fromDate && customDates.toDate) {
    const { fromDate, toDate } = DateRangeFn.fromVanillaDateArray(
      [new Date(customDates.fromDate), new Date(customDates.toDate)],
    ).toDBFormat();
    return ([{
      field: filterField,
      operator: 'between',
      value: [fromDate, toDate],
    }]);
  }
  // eslint-disable-next-line no-console
  console.error('Home filters: Some or all date limits missing for a Custom range date selected.');
  return [];
};

export const rangeDateOptions: Array<RangeDateOption> = [
  {
    key: 'This week',
    operator: 'date_current_calendar_week',
  },
  {
    key: 'This month',
    operator: 'date_current_calendar_month',
  },
  {
    key: 'This year',
    operator: 'date_current_calendar_year',
  },
  {
    key: 'Last week',
    operator: 'date_previous_calendar_week',
  },
  {
    key: 'All time',
    operator: 'array_all_of',
  },
  {
    key: 'Custom',
    operator: '',
  },
];

export default homeFilters;
